import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import LoadingBar from "react-top-loading-bar";
import { AssetSvg } from "../../assets";
import { AppConstants, PaginationSettings } from "../../configs";
import { useAppSelector, VRIAppStateType} from "../../core";
import { AdminPageTemplate, ColumnToolTip, ModalConfirmDelete, ModalModality } from "../../features";
import { ModalityResponseModel, } from "../../models/api/modality";
import { useFunctionalityPagedModality, useFunctionalityModality, } from "../hooks";

export function PageModality(): JSX.Element {
  const [modalShow, setModalShow] = React.useState(false);
  const [deleteModalShow, setDeleteModalShow] = React.useState(false);
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [dataToEdit, setDataToEdit] = React.useState<ModalityResponseModel | undefined>(undefined);
  const [dataToDelete, setDataToDelete] = useState<string[]>([]);
  const [searchText, setSearchText] = useState("");
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const data = useAppSelector((state: VRIAppStateType) => ({
    userRole: state.auth.profile?.userRole,
    companyId: state.auth.profile?.companyId
  }));

  const { onDeleteModality } = useFunctionalityModality(deleteModalShow);
  const { pagedModalityList, pagedModalityListCount } =
    useFunctionalityPagedModality({
      CompanyId: data.userRole === AppConstants.UserRoles.ResellerAdmin ? data.companyId : "",
      pageSize: pageSize,
      pageNo: pageIndex,
      searchText: searchText?.trimStart(),
      setLoaderProgress,
    });

  useEffect(() => {
    if (pagedModalityList?.length > 0) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedModalityList]);

  const onDeleteHandler = () => {
    onDeleteModality(dataToDelete)
      .then(() => {
        setDeleteModalShow(false);
      })
      .catch((e) => console.error(e));
  };

  const skillsTableColumns = [
    {
      name: <ColumnToolTip data="Name" />,
      selector: (row: ModalityResponseModel) => {
        return <ColumnToolTip data={row.name} />;
      },
    },
    // {
    //   name: "Pin",
    //   selector: (row: ModalityResponseModel) => row.pin,
    // },
    {
      name: <ColumnToolTip data="Service Type" />,
      selector: (row: ModalityResponseModel) => {
        return <ColumnToolTip data={row.serviceType} />;
      },
    },
    {
      name: <ColumnToolTip data="Actions" />,
      allowOverflow: true,
      selector: (row: ModalityResponseModel) => {
        return (
          <>
            <div
              className="btn svg-color"
              title="modalityEdit"
              onClick={() => {
                setDataToEdit(row);
                setModalShow?.(true);
              }}
            >
              <span >
                <AssetSvg.Edit />
              </span>
            </div>

            <div
              className="btn svg-color"
              title="modalityDelete"
              onClick={() => {
                setDeleteModalShow?.(true);
                setDataToDelete((prev) => [...prev, row.id]);
              }}
            >
              <span >
                <AssetSvg.Delete />
              </span>
            </div>
          </>
        );
      },
      omit: data.userRole === AppConstants.UserRoles.Admin ? false : true,
    },
  ];

  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <AdminPageTemplate
        pagingKey="PageModality"
        loaderProgress={loaderProgress}
        pageTitle="Modality"
        modalControlBtnLabel="Add Modality"
        tableHeaders={skillsTableColumns}
        tableData={pagedModalityList || []}
        setCreateModalShow={setModalShow}
        selectableRows={true}
        searchText={searchText}
        handleSearch={handleSearch}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        count={pagedModalityListCount}
        onChangePageIndex={onChangePageIndex}
        onChangePageSize={onChangePageSize}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
      />
      {modalShow ? (
        <ModalModality
          show={modalShow}
          handleShow={setModalShow}
          dataToEdit={dataToEdit}
          setDataToEdit={setDataToEdit}
        />
      ) : null}
      {deleteModalShow ? (
        <ModalConfirmDelete
          show={deleteModalShow}
          handleShow={setDeleteModalShow}
          deleteHandler={onDeleteHandler}
        />
      ) : null}
    </>
  );
}
